import { connect } from "react-redux";
import { PageRecoverPassword } from "senac-components";
import {
  PageRecoverPasswordDispatchProps,
  PageRecoverPasswordStateProps,
  RecoverPassword,
} from "senac-components/dist/pages/Mobile/PageRecoverPassword";
import { PageRecoveryPasswordWeb } from "senac-components/dist/pages/Web/PageRecoveryPasswordWeb";

import { AppDispatch, RootState } from "../store";
import { commonSlice, userSlice } from "../store/reducers";

const mapState = (state: RootState) => {
  let result: PageRecoverPasswordStateProps = {
    loading: state.userState.userAuthenticating,
  };

  return result;
};

const mapDispatch = (dispatch: AppDispatch) => {
  const result: PageRecoverPasswordDispatchProps = {
    onClickBack: () => dispatch(commonSlice.actions.backPage()),
    onClickRecoverPassword: (recoverPassword: RecoverPassword) =>
      dispatch(userSlice.actions.createPasswordFromRecovery(recoverPassword)),
  };

  return result;
};

const WPageRecoverPassword = () => {
  const Mobile = connect(mapState, mapDispatch)(PageRecoverPassword);
  const Web = connect(mapState, mapDispatch)(PageRecoveryPasswordWeb);
  if (window.innerWidth < 1024) return <Mobile />;
  return <Web />;
};

export { WPageRecoverPassword };
